import { render, staticRenderFns } from "./ServicesInfo.vue?vue&type=template&id=8b93c4c4&"
import script from "./ServicesInfo.vue?vue&type=script&lang=js&"
export * from "./ServicesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports